import { render, staticRenderFns } from "./modalRechazarPedidoDirecto.vue?vue&type=template&id=006a7a5d&scoped=true"
import script from "./modalRechazarPedidoDirecto.vue?vue&type=script&lang=js"
export * from "./modalRechazarPedidoDirecto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006a7a5d",
  null
  
)

export default component.exports